<script>
import CreateETickets from './create';
import EditETickets from './edit';
import ConfirmationModalComponent from "@/modules/checkin-facility/pages/dashboard/components/confirmation-modal.component";

import { eventBus } from "@/main";

export default {
   name: "ETickets",
   components: { CreateETickets, EditETickets, ConfirmationModalComponent },
   data() {
      return {
         couponList: {
            data: [],
         },
         pagination: {
            page: 1,
            per_page: 10,
            total: 0,
         },
         idToDelete: 0,
         showAlert: false,
      }
   },
   async mounted() {
      await this.getCouponList();
      eventBus.$on('closeCreateModal', () => {
         this.showAlert = true;
         setTimeout(() => {
            this.showAlert = false;
         }, 5000)
      })
   },
   methods: {
      async getCouponList(page) {
         if(page) this.pagination.page = page;
         const result = await this.$lionheart.get('/v2/coupons', {
            params: { facility_id: window._app_facility.id, ...this.pagination }
         }).then((success) => success.data.data);

         if(result.data.length > 0) {
            this.couponList = result
            this.pagination.per_page = result.per_page
            this.pagination.total = result.total == 0 ? 0 : result.total;
         }
      },
      processDeleteCoupon(couponId) {
         this.idToDelete = couponId;
         this.$bvModal.show('deleteCouponModal');
      },
      async submitDeleteCoupon() {
         await this.$lionheart
         .delete('/v2/coupons/'+this.idToDelete, { params: { facility_id: window._app_facility.id } }).then(response => response.data)
         .then((response) => {
            if(response.success) {
               this.$refs.scrollTop.scrollIntoView();
               this.showAlert = true;
               this.getCouponList()
            }
         }).catch((error) => console.log(error));
      },
      getPlanCode(planCode) {
         return planCode === 'no_plan_code' ? this.$t('account-page-facility-my-page-e-ticket.index.no_plan_code') : planCode;
      }
   }
}
</script>

<template>
   <div id="dashboard_wrapper" ref="scrollTop">
      <div class="col-lg-12" v-if="showAlert">
         <div class="alert alert-success" role="alert">
            {{ $t("account-page-facility-my-page-e-ticket.success_alert") }}
         </div>
      </div>
		<div class="card-body">
			<h4 class="card-title">
            {{ $t('account-page-facility-my-page-e-ticket.index.title') }}
         </h4>
			<p>
            {{ $t("account-page-facility-my-page-e-ticket.index.description") }}
         </p>

         <hr />
			<div class="row">
				<div class="col-lg-12" style="min-height: 400px;">
               <div class="d-flex justify-content-end mb-4">
                  <b-button variant="primary" size="lg" @click="$refs.createETickets.create()">
                     {{ $t("account-page-facility-my-page-e-ticket.index.create_text") }}
                  </b-button>
               </div>

               <div class="row">
                  <div class="col-lg-12 mb-3 table-responsive">

                     <table class="table table-bordered">
                        <thead>
                           <tr>
                              <th scope="col">#</th>
                              <th scope="col">
                                 {{ $t("account-page-facility-my-page-e-ticket.index.subject") }}
                              </th>
                              <th scope="col">
                                 {{ $t("account-page-facility-my-page-e-ticket.index.type") }}
                              </th>
                              <th scope="col">
                                 {{ $t("account-page-facility-my-page-e-ticket.index.valid_plan_codes")}}
                              </th>
                              <th scope="col">
                                 {{ $t("account-page-facility-my-page-e-ticket.index.action")}}
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                              <tr v-for="(value, key) in couponList.data" :key="key">
                                 <td>{{ key + 1 }}</td>
                                 <td>{{ value.subject }}</td>
                                 <td>{{ $t(`account-page-facility-my-page-e-ticket.type.${value.coupon_type_id}`) }}</td>
                                 <td>
                                    <b-badge
                                       v-for="(code, key) in value.plan_codes" :key="key" 
                                       pill
                                       variant="primary"
                                       class="mr-1"
                                    >
                                       {{ getPlanCode(code.plan_code) }}
                                    </b-badge>
                                 </td>
                                 <td class="text-center"> 
                                    <button type="button" class="btn btn-primary btn-block btn-sm mx-1"
                                       @click="$refs.editETickets.populateAndShowModal(value)"
                                    >
                                       {{ $t("account-page-facility-my-page-e-ticket.index.edit_text") }}
                                    </button>
                                    <button type="button" class="btn btn-danger btn-block btn-sm mx-1"
                                       @click="processDeleteCoupon(value.id)"
                                    >
                                       {{ $t("account-page-facility-my-page-e-ticket.index.delete_text") }}
                              </button>
                              </td>
                              </tr>

                        </tbody>
                     </table>
                     
                     <!-- pagination -->
                     <div class="row">
                        <div class="col-9">
                           <div class="float-left">
                              <pagination
                                 v-model="pagination.page"
                                 :per-page="pagination.per_page"
                                 :records="pagination.total"
                                 @paginate="getCouponList"
                                 :options="{texts: { count: '' }}"
                              />
                           </div>
                        </div>
                        <div class="col-3">
                           <div class="form-row">
                              <div class="col-6">
                                 <label class="float-right">
                                    <span class="align-middle">
                                       {{ $t("account-page-visitor.show") }}
                                    </span>
                                 </label>
                              </div>
                              <div class="col-4">
                                 <select
                                    class="form-control"
                                    v-model="pagination.per_page"
                                    required
                                    @change="getCouponList(1)"
                                 >
                                    <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                    <option :value="250">250</option>
                                    <option :value="500">500</option>
                                 </select>
                              </div>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>

               
            </div>
         </div>



         <div class="row mt-4">
            <div class="col-lg-12" align="center">
               <button @click.prevent="
                  $router.push({
                     name: 'checkin-facility-dashboard-my-page',
                  })
                  " class="btn btn-danger ml-3">
                  {{ $t("account-page-facility-my-page-e-ticket.index.back_text") }}
               </button>
            </div>
         </div>
      </div>
      <CreateETickets ref="createETickets" @closeModal="getCouponList"/>
      <EditETickets ref="editETickets" @closeModal="getCouponList"/>
      <ConfirmationModalComponent
         id="deleteCouponModal"
         message="Are you sure to delete this coupon?"
			@click-handler="submitDeleteCoupon" />
   </div>
</template>